import './style.scss';
import { Button, Form } from "react-bootstrap";
import { useState, useContext, useEffect } from "react";
import { Web3ModalContext } from "contexts/Web3ModalProvider";
import { IPFSContext } from 'contexts/IPFSProvider';
import { Web3WrapperContext } from 'contexts/Web3WrapperProvider';
import { NotificationManager } from 'react-notifications';
import {Oval} from "react-loader-spinner";
import CarouselNew from "../Crousel/CarouselNew";
import CarouselOne from "../CrouselOne/CarouselOne";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { setDashboard } from "../../store/reducers/DashboardSlice";

const Main = () => {

    const { account } = useContext(Web3ModalContext);
    const {ipfs, tokenID} = useContext(IPFSContext);
    const [cracePrice, setCracePrice] = useState(0);
    const [amount, setAmount] = useState(0);
    const [possibility, setPossibility] = useState(0);
    const [toxicAmount, setToxicAmount] = useState(0);
    const [nftInfo, setNftInfo] = useState([]);
    const { web3Wrapper: wrapper } = useContext(Web3WrapperContext);
    const dispatch = useAppDispatch();

    const getPrice = async () => {
        let crace : any = await wrapper?.getCracePrice_Toxic();
        let possibiity : any = await wrapper?.getPossibility_Toxic();
        let nftinfo : any = await wrapper?.getNfts_Toxic(account);
        console.log(nftinfo);
        let toxicAmount : any = await wrapper?.getToxicAmount_Toxic(account);
        setNftInfo(nftinfo);
        setCracePrice( parseInt(crace) / (10 ** 18) );
        setPossibility( 100 / parseInt(possibiity) );
        setToxicAmount(toxicAmount);
        console.log(possibiity);
        
        
    }

    useEffect(() => {
        getPrice();
    }, [wrapper]);

    useEffect(() => {
    }, [ipfs, tokenID]);

    const mint = async () => {
        if (amount === 0) NotificationManager.error(`Please input mint amount`, "Invalid Amount");
        else if(amount < 0) NotificationManager.error(`Amount must be greater than 0`, "Invalid Amount");
        else if(amount > 4000) NotificationManager.error(`Amount must be lesser than 4000`, "Invalid Amount");
        else {
            let modal:any = document.getElementById("myModal");
            modal.style.display = "block";
            try {
                let result = await wrapper?.mint_Toxic(amount);
                
                if(result === 9999) NotificationManager.error(`Minting has suspended`, "Failed");
                else {NotificationManager.success("Toxic NFTs Successfully Minted", "Confirmed");
                dispatch(setDashboard(0));
                }
                modal.style.display = "none";
            } catch(e) {
                console.log(e);
                modal.style.display = "none";
            }
            
        }
    }

    const mutate = async () => {
        if(!tokenID)    NotificationManager.error(`Please select a NFT you are going to mutate`, "Invalid Operation");
        // else await wrapper?.mutate(tokenID, account);
        else {
            let modal:any = document.getElementById("myModal");
            modal.style.display = "block";
            try {
                let result = await wrapper?.mutate_Toxic(tokenID, account);
                
                if(result === 9999) NotificationManager.error(`Mutating has suspended`, "Failed");
                else { NotificationManager.success("Successfully Mutated", "Confirmed");
                dispatch(setDashboard(0));
                }
                modal.style.display = "none";
            } catch(e) {
                console.log(e);
                modal.style.display = "none";
            }
            
        }
    }

    const amountChange = (event) => {
        setAmount(event.target.value);
    }

    const minusAmount = () => {
        if(amount > 0)
            setAmount(amount-1);
    }

    const plusAmount = () => {
        if(amount<4000)
            setAmount(amount+1);
    }


    return (
        <>
           
            <div className='price d-flex'>
                        <div className='classprice'>
                        <span className='colorNFT'>Toxic Ticket Price : </span><span className='colorPrice'>  {cracePrice} $CRACE</span>
                        </div>
            </div>
            <div className='price d-flex mt-2'>
                        <div className='possibilityPrice'>
                        <span className='colorNFT'>Possibility : {possibility}%</span>
                        </div>
             </div>
            <div className="d-flex mt-2 justify-content-center sizeIs">
                <Button className="minus-btn" onClick={minusAmount}>-</Button>
                <Form.Control type="number" onChange={amountChange} className="mint-amount" value={amount} placeholder="Amount" min="0" max="4000">
                </Form.Control>
                <Button className="plus-btn" onClick={plusAmount}>+</Button>
            </div>
            <div className="d-flex mt-2 justify-content-center">
                <Button className="btn-mint price" onClick={mint}>Buy Ticket</Button>
            </div>
            <hr></hr>
            <div className='price d-flex mt-2'>
                        <div className='possibilityPrice'>
                        <span className='colorNFT'>You Have Got {toxicAmount} Toxic NFTs.</span>
                        </div>
             </div>
            <div className="d-flex mt-2 justify-content-center">
            
            {possibility != 20 ? (
                <p>Please wait...</p>) : (<></>)
            }
            {possibility == 20 ? (
                <CarouselNew nftInfo={nftInfo}/>) : (<></>)
            }
            </div>
            {toxicAmount>0 ? (
                <div className="d-flex mb-4 justify-content-center">
                <Button className="btn-mint price" onClick={mutate}>Mutate</Button>
            </div>) : (
                <></>
            )}
            
            <CarouselOne ipfs={ipfs}></CarouselOne>
            <hr></hr>
            {/* <div className="d-flex mt-3 justify-content-center price">
                <h3>Minted NFT Cars</h3>
            </div>
            <div className="d-flex mt-1 justify-content-center price">
                <h1>{currentNftAmount}/{maxAmount}</h1>
            </div> */}
            <div id="myModal" className="modal-oval">
                <div className="modal-oval-content">
                    <Oval>
                        ariaLabel="loading-indicator"
                        height={100}
                        width={100}
                        strokeWidth={5}
                        color="red"
                        secondaryColor="yellow"
                    </Oval>
                <h3>Please wait for a moment</h3>
                </div>
            </div>
        </>
    );
}

export default Main;